import styled from 'styled-components'
import { Image } from 'react-bootstrap'

export const ProfilePicture = styled(Image)`
  width: auto;
  height: 66px;
`
